import { Navigate } from "react-router-dom";

import ForgotPassword from "../pages/ForgotPassword";
import Login from "../pages/Login";
import Signup from "../pages/Signup";
import Dashboard from "../pages/Dashboard";
import ResetPassword from "../pages/ResetPassword";
import User from "../pages/User";
import Setting from "../pages/Setting";
import LoadChatComponent from "../components/chat-component/LoadChatComponent";

const routesList = [
  {
    label: "Login",
    isProtected: false,
    Component: () => <Navigate to="/login" />,
    path: "/",
  },
  {
    label: "Dashboard",
    isProtected: true,
    Component: Dashboard,
    path: "/dashboard",
  },
  {
    label: "Users",
    isProtected: true,
    Component: User,
    path: "/manageusers",
  },
  {
    label: "Settings",
    isProtected: true,
    Component: Setting,
    path: "/settings",
  },
  {
    label: "Login",
    isProtected: false,
    Component: Login,
    path: "/login",
  },
  {
    label: "Signup",
    isProtected: false,
    Component: Signup,
    path: "/signup",
  },
  {
    label: "Forgotpassword",
    isProtected: false,
    Component: ForgotPassword,
    path: "/forgotpassword",
  },
  {
    label: "Resetpassword",
    isProtected: false,
    Component: ResetPassword,
    path: "/reset_password/:id",
  },
  {
    label: "Chat page",
    isProtected: true,
    isSidebarShow: false,
    Component: LoadChatComponent,
    path: "/chat/:id",
  },
  /*  {
    label: "Page Not Found",
    isProtected: false,
    Component: Login,
    path: "*",
  }, */
];

export default routesList;
